"use client";

import { Check, X } from "lucide-react";
import { ScrollReveal } from "@/components/ui/scroll-reveal";
import { cn } from "@/lib/utils";

const rows = [
  { feature: "Прибыль по каждому артикулу", mpunit: true, excel: false, manual: false },
  { feature: "Разбивка по размерам", mpunit: true, excel: false, manual: false },
  { feature: "Автоматический расчёт себестоимости", mpunit: true, excel: false, manual: false },
  { feature: "Данные без задержки отчёта WB", mpunit: true, excel: false, manual: false },
  { feature: "Прогноз поставок", mpunit: true, excel: false, manual: false },
  { feature: "Алерты когда товар в минусе", mpunit: true, excel: false, manual: false },
  { feature: "Обновляется автоматически", mpunit: true, excel: false, manual: false },
  { feature: "WB + Ozon в одном месте", mpunit: true, excel: false, manual: false },
];

function CellIcon({ value }: { value: boolean }) {
  return value ? (
    <Check className="w-4 h-4 text-emerald-400 mx-auto" />
  ) : (
    <X className="w-4 h-4 text-white/20 mx-auto" />
  );
}

export function ComparisonTable() {
  return (
    <section className="py-24 px-6 border-t border-white/[0.06]">
      <div className="max-w-3xl mx-auto">
        <ScrollReveal>
          <p className="text-sm font-medium text-purple-400 text-center mb-4">
            Сравнение
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white tracking-tight text-center">
            Хватит считать в Excel
          </h2>
          <p className="text-base text-white/50 text-center mt-4">
            43% селлеров зарабатывают меньше 10 000₽/мес. Те, кто считают — зарабатывают больше.
          </p>
        </ScrollReveal>

        {/* Таблица */}
        <ScrollReveal delay={0.15}>
          <div className="mt-12 rounded-xl border border-white/[0.08] overflow-hidden">
            {/* Заголовок */}
            <div className="grid grid-cols-[1fr_80px_80px_80px] md:grid-cols-[2fr_1fr_1fr_1fr] bg-white/[0.03]">
              <div className="px-5 py-3 text-xs text-white/40 font-medium">Возможность</div>
              <div className="px-3 py-3 text-xs text-white font-semibold text-center bg-purple-500/[0.08]">MPUNIT</div>
              <div className="px-3 py-3 text-xs text-white/40 font-medium text-center">Excel</div>
              <div className="px-3 py-3 text-xs text-white/40 font-medium text-center">Вручную</div>
            </div>

            {/* Строки */}
            {rows.map((row, i) => (
              <div
                key={row.feature}
                className={cn(
                  "grid grid-cols-[1fr_80px_80px_80px] md:grid-cols-[2fr_1fr_1fr_1fr] border-t border-white/[0.04]",
                  i % 2 === 0 ? "" : "bg-white/[0.01]"
                )}
              >
                <div className="px-5 py-3.5 text-sm text-white/70">{row.feature}</div>
                <div className="px-3 py-3.5 bg-purple-500/[0.04]">
                  <CellIcon value={row.mpunit} />
                </div>
                <div className="px-3 py-3.5">
                  <CellIcon value={row.excel} />
                </div>
                <div className="px-3 py-3.5">
                  <CellIcon value={row.manual} />
                </div>
              </div>
            ))}
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}
